<template>
  <div class="box box_mm">
    <div class="box_main">
      <div class="search_box">
        <div class="search_item">
          <span style="width: 0.8rem">标题：</span>
          <el-input
            v-model="searchinput"
            placeholder="请输入"
            style="width: 2rem"
          ></el-input>
        </div>
        <div class="search_item">
          <span style="width: 0.8rem">分类：</span>
          <el-select
            v-model="searchfenlei"
            placeholder="请选择"
            filterable
            clearable
            style="width: 2.3rem"
            @change="search"
          >
            <el-option
              v-for="item in classifyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-button type="primary" @click="search">搜索</el-button>
          <!-- <el-button type="success" @click="addnew">新建公文处理单</el-button> -->
        </div>
      </div>
      <div class="box_cont">
        <div class="btn_list"></div>
        <div style="height: 76vh; box-sizing: border-box">
          <MyTable
            ref="zjlist"
            :tableData="tableData"
            :tableHeader="tableHeader"
            :showbm="true"
            :czwidth="310"
            @getdata="gettable"
            @changswitch="changswitch"
          >
            <template slot="btns" slot-scope="{ scope }">
              <el-button
                @click="showdetail2(scope.row)"
                type="primary"
                size="mini"
                >详情</el-button
              >
              <el-button
                @click="showdetail(scope.row)"
                type="primary"
                size="mini"
                >查看文件</el-button
              >
            </template>
          </MyTable>
        </div>
      </div>
    </div>

    <detail
      v-if="showtcdetail"
      :id="nowid"
      @closedetail="showtcdetail = false"
    ></detail>

    <detail_tcsj
      v-if="showtcsjdetail"
      :id="nowid"
      @closedetail="showtcsjdetail = false"
    ></detail_tcsj>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { Message } from "element-ui";
import detail from "../detail_tc";
import detail_tcsj from "../detail_tcsj";
export default {
  components: {
    detail,
    Editor,
    Toolbar,
    detail_tcsj,
  },
  data() {
    return {
      searchinput: "",
      searchfenlei: "",
      classifyData: [],
      tableHeader: [
        {
          prop: "id",
          name: "序",
          width: "50",
        },
        {
          prop: "name",
          name: "标题",
          width: "",
        },
        {
          prop: "sqmytype_name",
          name: "所属类别",
          width: "150",
        },
        {
          prop: "sqmychannel_name",
          name: "来源渠道",
          width: "150",
        },
        {
          prop: "user_name",
          name: "发起人",
          width: "120",
        },
        {
          prop: "gbtype",
          name: "是否挂办",
          width: "120",
        },
        {
          prop: "state",
          name: "状态",
          width: "120",
          type: "sqmy_type",
        },
        {
          prop: "createtime",
          name: "创建时间",
          width: "150",
        },
      ],
      tableData: [],
      showtcdetail: false,
      showtcsjdetail: false,
      nowid: "",

      editor: null,
      dafuhan: "<p></p>", //答复函
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            server: this.$URL + "/api/login/upload",
            fieldName: "file",
            // 单个文件的最大体积限制，默认为 2M
            maxFileSize: 10 * 1024 * 1024, // 10M
            // 最多可上传几个文件，默认为 100
            maxNumberOfimgs: 100,
            // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
            allowedimgTypes: [],
            // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
            meta: {
              // otherKey: 'yyy'
              // img:''
            },
            // 将 meta 拼接到 url 参数中，默认 false
            metaWithUrl: false,

            // 自定义增加 http  header
            headers: {
              token: this.$store.state.userinfo.token,
              // otherKey: 'xxx'
            },

            // 跨域是否传递 cookie ，默认为 false
            withCredentials: false,

            // 超时时间，默认为 10 秒
            timeout: 10 * 1000, //10 秒

            // 上传前
            onBeforeUpload(imgs) {
              Message({
                message: "图片正在上传中,请耐心等待",
                grouping: true,
                duration: 0,
                customClass: "uploadTip",
                iconClass: "el-icon-loading",
                showClose: true,
              });
              return imgs;
            },
            // 自定义插入图片
            customInsert(res, insertFn) {
              // 因为自定义插入导致onSuccess与onFailed回调函数不起作用,自己手动处理
              // 先关闭等待的ElMessage
              Message.closeAll();

              if (res.code === 200) {
                Message.success({
                  message: "图片上传成功",
                  grouping: true,
                });
              } else {
                Message.error({
                  message: "图片上传失败，请重新尝试",
                  grouping: true,
                });
              }
              // 从 res 中找到 url alt href ，然后插入图片
              insertFn(res.fullurl);
              // console.log(res, "res.data")
            },

            // 单个文件上传成功之后
            onSuccess(img, res) {
              console.log(`${img.name} 上传成功`, res);
            },

            // 单个文件上传失败
            onFailed(img, res) {
              console.log(`${img.name} 上传失败`, res);
            },

            // 上传进度的回调函数
            onProgress(progress) {
              console.log("progress", progress);
              // progress 是 0-100 的数字
            },

            // 上传错误，或者触发 timeout 超时
            onError(img, err, res) {
              console.log(`${img.name} 上传出错`, err, res);
            },
          },

          // 上传视频
          uploadVideo: {
            server: this.$URL + "/api/login/upload",
            fieldName: "file",
            // 单个文件的最大体积限制，默认为 10M
            maxFileSize: 500 * 1024 * 1024, // 500M
            // 最多可上传几个文件，默认为 5
            maxNumberOfFiles: 3,
            // 选择文件时的类型限制，默认为 ['video/*'] 。如不想限制，则设置为 []
            allowedFileTypes: ["video/*"],
            // 将 meta 拼接到 url 参数中，默认 false
            metaWithUrl: false,
            // 自定义增加 http  header
            headers: {
              token: this.$store.state.userinfo.token,
              // otherKey: 'xxx'
            },
            // 跨域是否传递 cookie ，默认为 false
            withCredentials: false,
            // 超时时间，默认为 30 秒
            timeout: 30 * 1000, // 15 秒
            onBeforeUpload(imgs) {
              Message({
                message: "正在上传中,请耐心等待",
                grouping: true,
                duration: 0,
                customClass: "uploadTip",
                iconClass: "el-icon-loading",
                showClose: true,
              });
              return imgs;
            },
            // 自定义插入图片
            customInsert(res, insertFn) {
              // 因为自定义插入导致onSuccess与onFailed回调函数不起作用,自己手动处理
              // 先关闭等待的ElMessage
              Message.closeAll();

              if (res.code === 200) {
                Message.success({
                  message: "视频上传成功",
                  grouping: true,
                });
              } else {
                Message.error({
                  message: "上传失败，请重新尝试",
                  grouping: true,
                });
              }
              // 从 res 中找到 url alt href ，然后插入图片
              insertFn(res.fullurl);
              // console.log(res, "res.data")
            },
            // 上传进度的回调函数
            onProgress(progress) {
              console.log("progress", progress);
            },
            // 单个文件上传成功之后
            onSuccess(file, res) {
              console.log(`${file.name} 上传成功`, res);
            },
            // 单个文件上传失败
            onFailed(file, res) {
              console.log(`${file.name} 上传失败`, res);
            },
            // 上传错误，或者触发 timeout 超时
            onError(file, err, res) {
              console.log(`${file.name} 上传出错`, err, res);
            },
          },
        },
      },

      czid: "",
      jindutxet: "",
      jindufankui: false,
      islook: false,
      jinduIndex: 1,
    };
  },
  mounted() {
    this.$post({
      url: "/api/sqmytype/index",
      params: {
        p: 1,
        size: 9999,
      },
    }).then((res) => {
      this.classifyData = res.list;
    });
    this.gettable();
  },
  methods: {
    showdetail2(row) {
      this.nowid = row.id;
      this.showtcsjdetail = true;
    },
    closejindu() {
      this.jindufankui = false;
      this.showtcdetail = false;
      this.jindutxet = "";
    },
    openjindu(item) {
      this.czid = item.id;
      this.jindufankui = true;
    },
    showdetail(row) {
      this.nowid = row.id;
      this.showtcdetail = true;
    },
    postdata(row) {},
    showeidt(row) {
      this.$router.push("/system/get_file/edit?id=" + row.id);
    },
    changswitch(row) {
      this.$post({
        url: "/api/room/edit",
        params: row,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.gettable();
      });
    },
    search() {
      this.$refs.zjlist.inputpage = 1;
      this.gettable();
    },
    gettable() {
      this.$post({
        url: "/api/sqmy/quanindex",
        params: {
          name: this.searchinput,
          sqmytype_id: this.searchfenlei,
          p: this.$refs.zjlist.inputpage,
          size: this.$refs.zjlist.pagesize,
          state: 10,
          hqtype: 2,
        },
      }).then((res) => {
        res.list.map((item) => {
          item.gbtype = item.gbtype == 2 ? "挂办" : "";
          return item;
        });
        this.tableData = res.list;
        this.$refs.zjlist.total = res.count;
      });
    },
    addnew() {
      this.$router.push("/system/get_file/add");
    },
    showdate(row) {
      this.$refs.myroomdate.dialogVisible = true;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="scss" scoped>
@import "../list.scss";
</style>
